import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from "@angular/core"
import { Observable, of } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { IAppState } from '../store/state/app.state';
import { LoginUsersSuccess } from '../store/actions/login.actions';
@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(public toastr: ToastrService,
    private router: Router,
    private _store: Store<IAppState>
  ) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      tap(evt => {
        if (evt instanceof HttpResponse) {
          // check session timeout
          if (evt.body != null) {
            switch (evt.body.code) {
              case -2:
                this.toastr.error("Phiên làm việc hết hiệu lực", "Vui lòng đăng nhập lại");
                this.goToLoginPage();
                break;
              case -9:
                this.toastr.warning("Vui lòng kiểm tra lại", "Yêu cầu không hợp lệ");
                break;
              default: break;
            }
          }
        }
      }),
      catchError((err: any) => {
        return of(err);
      }));
  }

  goToLoginPage() {
    this._store.dispatch(new LoginUsersSuccess(null));
    this.router.navigate(['login']);
  }
}
